import { Zap, FileText } from "lucide-react";
import { motion } from "motion/react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

export function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-emerald-600 via-cyan-600 to-emerald-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQyIiB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPjxwYXRoIGQ9Ik0gMTAgMCBMIDAgMCAwIDEwIiBmaWxsPSJub25lIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZDIpIi8+PC9zdmc+')]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white mb-6">
              Join the Green Energy Revolution
            </h2>

            <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto">
              Make the switch today and power your business with 100% verified renewable energy. Get instant GEC certificates and contribute to a sustainable future.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <a
                // href={`${import.meta.env.VITE_API_URL}/auth/login`}
                target="_blank"
                rel="noopener noreferrer"
                className="group px-8 py-4 bg-white text-emerald-600 rounded-lg hover:shadow-2xl transition-all flex items-center justify-center gap-3"
              >
                <Zap className="w-5 h-5 group-hover:animate-pulse" />
                Activate Green Tariff Now
              </a>

              <button className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 transition-colors flex items-center justify-center gap-3">
                <FileText className="w-5 h-5" />
                View Sample GEC Certificate
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12">
              <div className="text-white">
                <p className="text-3xl md:text-4xl mb-2">70+</p>
                <p className="text-sm md:text-base text-white/80">Active Users</p>
              </div>
              <div className="text-white">
                <p className="text-3xl md:text-4xl mb-2">4,560+</p>
                <p className="text-sm md:text-base text-white/80">MWh Matched</p>
              </div>
              <div className="text-white">
                <p className="text-3xl md:text-4xl mb-2">93%</p>
                <p className="text-sm md:text-base text-white/80">Clean Energy</p>
              </div>
              <div className="text-white">
                <p className="text-3xl md:text-4xl mb-2">24/7</p>
                <p className="text-sm md:text-base text-white/80">Monitoring</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
